function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MimeType from '../utils/mime-type';
var Item = /*#__PURE__*/function () {
  function Item() {
    _classCallCheck(this, Item);
    /**
     * @type {boolean}
     */
    this.boost = false;
    /**
     * @type {string[]}
     */
    this.contentTypes = [];

    /**
     * @type {string}
     */
    this.date = '';
    /**
     * @type {boolean}
     */
    this.downloadDirectly = false;
    /**
     * @type {string[]}
     */
    this.filters = [];
    /**
     * @type {boolean}
     */
    this.forceLock = false;
    /**
     * @type {boolean}
     */
    this.generateThumbnail = true;
    /**
     * @type {boolean}
     */
    this.hidden = false;
    /**
     * @type {string}
     */
    this.id = '';
    /**
     * @type {string}
     */
    this.image = '';
    /**
     * @type {boolean}
     */
    this.locked = false;
    /**
     * @type {string}
     */
    this.mimeType = '';
    /**
     * @type {string}
     */
    this.name = '';
    /**
     * @type {string}
     */
    this.text = '';
    /**
     * @type {string}
     */
    this.url = '';
  }
  return _createClass(Item, [{
    key: "shouldDownload",
    value: function shouldDownload() {
      return this.locked || this.downloadDirectly || this.mimeType === MimeType.EXTERNAL;
    }
  }], [{
    key: "fromEndpoint",
    value: function fromEndpoint(data) {
      var item = new Item();
      item.boost = data.boost;
      item.contentTypes = data.contentTypes;
      item.date = item.date;
      item.downloadDirectly = data.downloadDirectly;
      item.filters = data.filters;
      item.forceLock = data.forceLock;
      item.generateThumbnail = data.generateThumbnail;
      item.hidden = data.hidden;
      item.id = data.id;
      item.image = data.image;
      item.locked = data.locked;
      item.mimeType = data.mimeType;
      item.name = data.name;
      item.text = data.text;
      item.url = data.url;
      return item;
    }
  }]);
}();
export { Item as default };